<script>
import HeaderTopbar from 'components/common/HeaderTopbar'
import TextButton from 'components/common/TextButton'

export default {
  name: 'DataAcquisitionAndAnalyticsProduct',

  components: { HeaderTopbar, TextButton },

  methods: {
    toTrialPage () {
      this.$router.push({name: 'trial'})
    }
  }
}
</script>

<template lang="pug">
section.product-data-acquisition-analytics.dm-corp-page
  header-topbar(theme="invert" active-item="products"
                scroll-bg="#3836AC" scroll-theshold="100" watch-scroll)

  section.above-the-fold
    .hero-texts-container
      .main-container
        h1.hero-title 心理数据智能采集与分析
        .description 科学性与专业性<br/>有赖于行业领先的经验和技术
        .cta-buttons
          text-button(theme="secondary-gradient" size="large" rounded @click="toTrialPage") 预约专家互动

  section.key-features
    .main-container
      .key-features-list
        .key-feature-block.placeholder &nbsp;

        .key-feature-block
          .block-image
            .dmico-data-key-1
          .block-title 学业有专攻
          .block-text 成员均来自海内外知名学府和心理学机构

        .key-feature-block
          .block-image
            .dmico-data-key-2
          .block-title 技术领先
          .block-text 团队独立研发数百个专业级心理测量工具

        .key-feature-block
          .block-image
            .dmico-data-key-3
          .block-title 追求卓越
          .block-text 不断探索新技术的运用和用户体验的完善

        .key-feature-block
          .block-image
            .dmico-data-key-4
          .block-title 服务专业
          .block-text 善于针对各种复杂业务需求提出解决方案

        .key-feature-block
          .block-image
            .dmico-data-key-5
          .block-title 经验丰富
          .block-text 迄今超过500万人次多维度心理数据积累

        .key-feature-block
          .block-image
            .dmico-data-key-6
          .block-title 客户信赖
          .block-text 为不同行业上百个大型项目提供专业支持
        
        .key-feature-block.placeholder &nbsp;
  
  section.what-we-do
    .partial-bg.right(v-lazy:background-image="`${require('assets/images/data-bg-partial-r.png')}`")
    .partial-bg.left(v-lazy:background-image="`${require('assets/images/data-bg-partial-l.png')}`")

    .main-container
      h2.section-title 不止是问卷发放<br/>我们能为您做到更多
      .section-intro 市面上可用于发放问卷的表单系统有很多，只有DiggMind能为您提供更专业的心理数据采集与分析服务

      .section-parts.odd
        .parts-texts
          h3.parts-title
            .deco-icon.dmico-hexagon-orange
            span 科学设计
          ul.parts-list
            li
              .deco-li.dmico-connector-blue
              | 专业齐全的心理评估工具库，从经典量表到行业定制，保证评估手段的科学性；
            li
              .deco-li.dmico-connector-blue
              | 根据具体的业务需求和场景特征，组合运用不同工具，提升评估方案的合理性；
            li
              .deco-li.dmico-connector-blue
              | 基于理论和经验模型，创建不同层次的综合分析指标，增强评估结果的实用性。
        .parts-image(v-lazy:background-image="`${require('assets/images/data-wwd-design.png')}`")

      .section-parts.even
        .parts-texts
          h3.parts-title
            .deco-icon.dmico-hexagon-orange
            span 智能采集
          ul.parts-list
            li
              .deco-li.dmico-connector-blue
              | 独家采用各种递进式、分阶段、随机化设计，能够实时、动态地匹配评估内容；
            li
              .deco-li.dmico-connector-blue
              | 独家实现对于伪装、欺骗行为的智能鉴别和实时应对，能够保障数据真实有效；
            li
              .deco-li.dmico-connector-blue
              | 独家支持各种多媒体呈现手法和测量学专业范式，能够满足前沿学术研究需要。
        .parts-image(v-lazy:background-image="`${require('assets/images/data-wwd-collect.png')}`")

      .section-parts.odd
        .parts-texts
          h3.parts-title
            .deco-icon.dmico-hexagon-orange
            span 自动分析
          ul.parts-list
            li
              .deco-li.dmico-connector-blue
              | 独家支持各种复杂的计分公式和判断方式，深挖大数据、多维度间的影响关系；
            li
              .deco-li.dmico-connector-blue
              | 独家实现个人报告与团体分析结果的实时生成反馈，让项目实施变得异常轻松；
            li
              .deco-li.dmico-connector-blue
              | 独家支持周期性持续评估，能够对重测数据进行自动跟踪比对、描绘变化轨迹。
        .parts-image(v-lazy:background-image="`${require('assets/images/data-wwd-analyse.png')}`")

  section.your-needs(v-lazy:background-image="`${require('assets/images/data-bg-huge-hexagon.png')}`")
    .needs-container.main-container
      ul.needs-list
        li.needs-block.extra-margin
          .block-icon.dmico-info-hexagon-orange
          .block-text 找不到适切可用的心理评估工具；不知道如何组合运用多个评估工具、进行多维度分析。

        li.needs-block
          .block-icon.dmico-info-hexagon-orange
          .block-text 题目量太少，获取的信息量不足；题量设计得太多，又会为接受评估的人带来不便。

        li.needs-block
          .block-icon.dmico-info-hexagon-orange
          .block-text 不知道如何深挖数据，并提炼为几个核心指标；不知道如何结合科学理论，撰写出一份有影响力的报告。

        li.needs-block
          .block-icon.dmico-info-hexagon-orange
          .block-text 对数据的真实有效性有较高的要求；对评估方法的科学性或者创新性有较高的要求。

        li.needs-block.extra-margin
          .block-icon.dmico-info-hexagon-orange
          .block-text 需要为接受评估的人自动提供个人报告；需要进行定期的评估，分析变化趋势、发现背后的规律。

        li.needs-block
          .block-icon.dmico-info-hexagon-orange
          .block-text 需要进行专业学术研究，研究方法涉及到一些较为复杂的条件和阶段设置，市场上其他在线问卷系统均无法满足需要。

      .cta-area
        h2.section-title 如果您遇到以上情况<br/>请即刻联系DiggMind专家
        text-button(theme="secondary-gradient" size="large" rounded @click="toTrialPage") 预约专家互动

    .cta-footer
      .main-container
        p 马上体验真正专业的心理数据采集与分析服务！
        p 联系我们，让DiggMind专业团队免费为您提供项目实施的解决思路和方法。
        text-button(theme="secondary-gradient" size="large" rounded @click="toTrialPage") 预约专家互动

</template>

<style lang="scss">
@import "../styles/variables";

$lightPurple: #3F45BA;

section.product-data-acquisition-analytics.dm-corp-page {
  margin-top: 0;

  .above-the-fold {
    box-sizing: border-box;
    width: 100%;
    padding-top: 60%;
    position: relative;
    z-index: 0;
    min-height: 860px;
    
    background-color: #fff;
    background-image: url(../assets/images/data-hero-image.png), url(../assets/images/data-hero-bg-color.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center top;

    .hero-texts-container {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      padding-top: calc(80px + 8%);
    }

    .hero-title {
      font-size: 38px;
      font-weight: 800;
      line-height: 100%;
      margin-bottom: 15px;
      color: #fff;
    }

    .description {
      color: #fff;
      font-size: 22px;
      line-height: 150%;
    }

    .cta-buttons {
      padding-top: 30px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;

      .text-button {
        box-shadow: 0 11px 20px rgba(20, 20, 137, 0.4);
        transition: box-shadow .3s;

        &:hover {
          box-shadow: 0 5px 15px rgba(20, 20, 137, 0.3);
        }
      }
    }

    @media (max-width: 1440px) {
      background-size: cover;

      .hero-texts-container {
        padding-top: calc(80px + 15%);
      }
    }
  }

  .section-title {
    font-size: 36px;
    font-weight: 600;
    line-height: 130%;
  }

  .key-features {
    position: relative;
    z-index: 10;
    margin-top: -15%;

    .key-features-list {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: stretch;
      align-content: flex-start;
    }

    .key-feature-block {
      width: 23%;
      padding: 40px;
      margin-bottom: 40px;

      border-radius: 20px;
      background: #fff;
      box-shadow: 0 10px 30px transparentize($lightPurple, 0.9);

      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      text-align: center;

      .block-title {
        font-size: 18px;
        font-weight: 600;
        margin-top: 30px;
        line-height: 100%;
      }

      .block-text {
        font-size: 14px;
        line-height: 150%;
        padding-top: 20px;
        color: $text-gray;
      }

      &.placeholder {
        background: transparent;
        box-shadow: none;
      }
    }

    @media (max-width: 1440px) {
      .key-feature-block {
        width: 30%;

        &.placeholder {
          display: none;
        }
      }
    }

    @media (max-width: 680px) {
      .key-feature-block {
        width: 47%;
      }
    }
  }

  .what-we-do {
    margin-top: 100px;
    position: relative;

    .partial-bg {
      @include bgImage;
      position: absolute;
      z-index: 0;

      &.right {
        width: 265px;
        height: 355px;
        right: 0;
        top: 60px;
      }

      &.left {
        width: 295px;
        height: 320px;
        left: 0;
        top: 50%;
      }
    }

    .main-container {
      position: relative;
      z-index: 5;
    }

    .section-title {
      text-align: center;
    }

    .section-intro {
      font-size: 14px;
      line-height: 150%;
      width: 70%;
      max-width: 540px;
      margin: 0 auto;
      padding-top: 15px;
      text-align: center;
      color: $text-gray;
    }

    .section-parts {
      margin: 60px auto 0 auto;
      max-width: 750px;
      position: relative;

      &.odd {
        .parts-image {
          right: 30px;
        }
      }

      &.even {
        .parts-image {
          left: 30px;
        }

        .parts-texts {
          margin-left: auto;
        }
      }
    }

    .parts-title {
      font-size: 18px;
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: flex-start;
      .deco-icon {
        position: relative;
        top: -6px;
      }
    }

    .parts-texts {
      max-width: 340px;
    }

    ul.parts-list {
      margin: 0 0 0 60px;
      padding: 0;

      li {
        list-style: none;
        position: relative;
        color: $text-gray;
        margin-top: 20px;
        font-size: 14px;
        line-height: 200%;

        .deco-li {
          position: absolute;
          top: -10px;
          left: -40px;
        }

        &:first-of-type {
          margin-top: -5px;
        }
      }
    }

    .parts-image {
      @include square(280px);
      @include bgImage;
      position: absolute;
      top: 50%;
      transform: translate3d(0, -50%, 0);
    }
  }

  .your-needs {
    @include bgImage;
    background-position: top center;
    background-size: 100% auto;
    margin-top: 50px;
    padding-top: 90px;

    .needs-container {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
    }

    ul.needs-list {
      margin: 0;
      padding: 0;
      list-style: none;

      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      align-items: stretch;
      align-content: flex-start;

      max-width: 760px;

      li {
        background: #fff;
        border-radius: 20px;
        padding: 20px 40px 30px 40px;
        width: 270px;
        box-shadow: 0 10px 30px transparentize($lightPurple, 0.9);
        position: relative;
        margin-right: 40px;
        margin-bottom: 40px;

        .block-icon {
          position: relative;
          left: -20px;
        }
        
        .block-text {
          margin-top: -5px;
          font-size: 14px;
          line-height: 150%;
        }

        &.extra-margin {
          margin-left: 100px;
        }
      }
    }

    .cta-area {
      text-align: right;

      .section-title {
        padding-bottom: 30px;
      }

      .text-button {
        box-shadow: 0px 11px 20px 0px rgba(255, 106, 39, 0.3);
        transition: box-shadow .3s;
        &:hover {
          box-shadow: 0px 5px 15px 0px rgba(255, 106, 39, 0.4);
        }
      }
    }

    @media (max-width: 1440px) {
      .needs-container {
        display: block;
      }

      ul.needs-list {
        max-width: none;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        li {
          margin-left: 20px;
          margin-right: 20px;
          &.extra-margin {
            margin-left: 20px;
          }
        }
      }

      .cta-area {
        margin-top: 40px;
        text-align: center;
      }
    }
  }

  .cta-footer {
    position: relative;
    z-index: 5;
    height: 670px;
    background-image: url(../assets/images/data-footer-image.png), url(../assets/images/data-footer-bg.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;

    position: relative;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;

    .main-container {
      flex: 1 1 0.0001px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      text-align: center;

      padding-top: 100px;

      p {
        color: #fff;
        font-size: 22px;
        line-height: 130%;
        padding-top: 10px;

        &:first-of-type {
          padding-top: 0;
        }
      }
    }

    .text-button {
      margin-top: 40px;
      box-shadow: 0 11px 20px rgba(20, 20, 137, 0.4);
      transition: box-shadow .3s;

      &:hover {
        box-shadow: 0 5px 15px rgba(20, 20, 137, 0.3);
      }
    }
  }
}
</style>
